import idLocale from 'element-ui/lib/locale/lang/id' //引入element语言包 印尼语
const id = {
  posterPage: {
    title1:'Fitur langganan akan segera tersedia!',
    title2:'Pembaruan langganan, peningkatan istimewa!',
    title3:'Diskon eksklusif, perbaruan lebih hemat',
    title4:'Untuk mendapatkan kode pertukaran, Anda dapat berkonsultasi dengan penjual yang membeli peralatan',
    title5:'Prioritas Pengalaman',
    function1:'Detail fungsi:',
    function2:'Pembaruan layanan dasar (penerjemah simultan, asisten konferensi, asisten cerdas)...',
    function3:'Langganan layanan nilai tambah (terjemahan offline, terjemahan panggilan audio dan video)...',
  },
  RedemptionCodePage: {
    RedemptionCode: 'Kode penebusan',
    ValueAddedServices: 'layanan nilai tambahan',
    UpgradedExperience: 'keuntungan-nilai tambahan eksklusif, pengalaman terbaik',
    OfflineTranslation: 'Terjemahan luar talian',
    NoInternet: 'Tidak perlu koneksi internet, terjemahan instan, aman dan dipercaya',
    GoToSubscribe: 'Pergi mendaftar',
    AudioAndVideoCall: 'Audio/Video Call',
    RealTimeCall: 'Terjemahan suara dan aksesibilitas komunikasi saat nyata',
    BaseService: 'Layanan dasar',
    AIAssistant: 'Fungsi: interpretasi simultan, asisten konferensi, asisten AI',
    LanguagesSetting:'Pengaturan bahasa',
    languages1:'Bahasa Cina Sederhana',
    languages2:'Bahasa Cina Tradisional',
    languages3:'Bahasa Inggris',
    languages4:'Jepang',
    languages5:'bahasa korea',
    languages6:'bahasa Rusia',
    languages7:'Bahasa Spanyol',
    languages8:'bahasa Prancis',
    languages9:'bahasa Jerman',
    languages10:'Bahasa Portugis',
    languages11:'Bahasa Italia',
    languages12:'Bahasa Turki',
    languages13:'bahasa vietnam',
    languages14:'Bahasa Indonesia',
    languages15:'Bahasa Hindi',
    languages16:'bahasa Arab',
    languages17:'bahasa Thailand',
    languages18:'Bahasa Persia',
  },
  Login: {
    ToLogin: 'log on',
    PhoneLogin: 'Login dengan nomor telepon',
    EmailLogin: 'Login Email',
    PhonePlaceholder: 'Silakan masukkan nomor telepon Anda',
    EmailPlaceholder: 'Enter email',
    Code: 'Kode verifikasi',
    and: 'dan',
    BeforeText: 'Membuat akun mewakili kesepakatan dan persetujuan Anda',
    UserAgreement: 'Perjanjian Pengguna',
    privacy: 'Polisi Privasi',
    errorMessage: 'Galat kode verifikasi',
    readTitle: 'Baca dan setuju dengan kesepakatan berikutnya',
    readBefore: 'Untuk memastikan keamanan informasi pribadi Anda, silakan baca dan setuju pertama',
    cancel: 'batalkan',
    agree: 'Setuju dan lanjutkan',
    error1:'Silakan masukkan alamat email yang sah',
    error2:'Masukkan nomor ponsel yang benar',
    error3:'Silakan masukkan kode verifikasi',
    success:'Login berhasil'
  },
  OffLinePage: {
    title: 'Terjemahan luar talian',
    NoInternet: 'Tidak perlu koneksi internet, terjemahan instan, aman dan dipercaya',
    ServiceLife: 'kehidupan layanan',
    forever: 'Penggunaan Permanen',
    describe: 'Instruksi Subskripsi',
    describeItem1: '1. Fungsi terjemahan offline adalah pembayaran satu kali, penggunaan permanen, dan izin penggunaan mengikuti perangkat Bluetooth. Jika Anda mengubah perangkat, Anda perlu mendaftar ke kode penebusan terjemahan offline lagi.',
    describeItem2: '2. Pencatatan kode otorisasi tidak dapat dikembalikan.',
    describeItem3: '3. Mendukung 10 bahasa: Cina, Inggris, Jerman, Jepang, Korea, Hindi, Thailand, Spanyol, Prancis, Rusia.',
    quantity: 'jumlah',
    payType: 'Metode pembayaran',
    card: 'Kartu Bank',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'mendaftar ke',
    RMB: '¥',
    confirm:'konfirmasi',
    cardNumber:'Nomor kartu',
    periodOfValidity:'periode validitas',
    safetyCode:'kode keselamatan',
    name:'nama penuh',
    yearAndMonth:'Tahun/Bulan',
    message1:'Jumlahnya tidak bisa 0',
    popTip:'Tips',
    popText1:'Silakan baca dan pahami dengan hati-hati.',
    popText2:'Perjanjian Terjemahan Offline',
    popText3:'Saya sudah membaca dan setuju',
    popText4:'Sudah dibaca dan setuju',
  },
  AudioVideoPage: {
    title: 'Audio/Video Call',
    RealTime: 'Terjemahan suara dan aksesibilitas komunikasi saat nyata',
    describe: 'Instruksi Subskripsi',
    describeItem1: '1. Fungsi terjemahan panggilan audio dan video adalah untuk memuat ulang dan membeli menit. Kiraan menit dari waktu panggilan terhubung, dan izin mengikuti rekening. Jika Anda log masuk ke rekening lain, Anda harus memuat ulang lagi.',
    describeItem2: '2. Setelah memuat ulang rekening, koneksi dan mengikat perangkat berbeda masih dapat digunakan seperti biasa.',
    describeItem3: '3. Fungsi terjemahan panggilan audio dan video tidak dapat dikembalikan setelah memuat ulang.',
    payType: 'Metode pembayaran',
    card: 'Kartu Bank',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'mendaftar ke',
    RMB: '¥',
    sale: 'diskon',
    confirm:'konfirmasi',
    time1:'detik',
    time2:'Menit',
    time3:'jam',
    time4:'hari',
    time5:'bulan',
    time6:'Tahun',
  },
  OffLineResult: {
    title1: 'Terjemahan luar talian',
    title2: 'Audio/Video Call',
    title3: 'Layanan dasar',
    success: 'Subskripsi berhasil',
    fail: 'Langganan gagal',
    stock:'Kode pertukaran tersedia',
    saveTitle: 'Simpan kode penebusan dan pergi ke aplikasi untuk menebusnya',
    code: 'Kode penebusan',
    tip1: 'Kode ini hanya digunakan untuk menebus fungsi terjemahan offline',
    tip2: 'Kode ini hanya digunakan untuk menebus fungsi terjemahan panggilan audio/video',
    tip3: 'Kode ini hanya digunakan untuk menebus fungsi pembaruan layanan dasar',
    save: 'simpan',
    time: 'Waktu subskripsi:',
    copy: 'Salin',
    copySuccess: 'Mengulangi Sukses',
    loading:'Memuat',
    paySuccess:'Pembayaran berhasil'
  },
  RedemptionList: {
    title: 'My redemption code',
    view: 'tampilan',
    time: 'Waktu subskripsi:',
  },
  MyRedemption: {
    title: 'My redemption code',
    code: 'Kode penebusan',
    time: 'Waktu subskripsi:',
    copy: 'Salin',
    tip1: 'Kode ini hanya digunakan untuk menebus fungsi terjemahan offline',
    tip2: 'Kode ini hanya digunakan untuk menebus fungsi terjemahan panggilan audio/video',
    tip3: 'Kode ini hanya digunakan untuk menebus fungsi pembaruan layanan dasar',
    save: 'simpan',
    success:"Operasi berhasil"
  },
  basePage:{
    error1:'Tidak ada informasi produk',
    message1:'Silakan pilih produk',
    title:'Layanan dasar',
    function:'Fungsi: interpretasi simultan, asisten konferensi, asisten AI',
    describe: 'Instruksi Subskripsi',
    describe1:'1. Setelah pembangunan layanan dasar seperti simultan interpretasi terjemahan dan asisten konferensi, periode kehendak mengikuti peralatan. Jika peralatan diganti, itu perlu diperbaiki.',
    describe2:'2. Layanan dasar tidak dapat dikembalikan setelah pembaruan.',
    payType: 'Metode pembayaran',
    card: 'Kartu Bank',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'mendaftar ke',
    RMB: '¥',
    sale: 'diskon',
    month:'bulan',
    confirm:'konfirmasi',
    month1:'1 bulan',
    month2:'Setengah tahun',
    month3:'1 tahun'
  },
  ...idLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default id;
